import { CssDevice } from '@gig/magic-common';
import { BREAKPOINT_DEVICE_QUERY, BREAKPOINT_LANDSCAPE_QUERY, BREAKPOINT_FULLSCREEN_UPDATED, BREAKPOINT_DEVICE_UPDATED, BREAKPOINT_LANDSCAPE_UPDATED } from '@gig/magic-messages';

var CssBreakpointsV2Service = /** @class */ (function () {
    function CssBreakpointsV2Service(breakpoints, deviceService) {
        this.deviceService = deviceService;
        this.devices = [
            CssDevice.MOBILE,
            CssDevice.PHABLET,
            CssDevice.TABLET,
            CssDevice.DESKTOP,
            CssDevice.LARGE,
        ];
        this.mediaQueryListeners = [];
        this.landscapeMediaQueryListener = null;
        this.registerBreakpointQuery();
        this.registerBreakpointEvents();
        this.setup(breakpoints);
    }
    CssBreakpointsV2Service.prototype.registerBreakpointQuery = function () {
        var _this = this;
        window.queryBus.subscribe(BREAKPOINT_DEVICE_QUERY, function () {
            return _this.device;
        });
        window.queryBus.subscribe(BREAKPOINT_LANDSCAPE_QUERY, function () {
            return _this.landscape;
        });
    };
    CssBreakpointsV2Service.prototype.registerBreakpointEvents = function () {
        window.eventBus.register(BREAKPOINT_FULLSCREEN_UPDATED, {
            type: 'boolean',
        });
    };
    CssBreakpointsV2Service.prototype.setup = function (breakpoints) {
        var _this = this;
        if (typeof window.matchMedia !== 'undefined') {
            this.mediaQueryListeners = this.devices.map(function (device) {
                var mqListener = matchMedia("(min-width: " + breakpoints[device].width + "px)");
                mqListener.addEventListener('change', function () {
                    _this.device = _this.lastMatch;
                    _this.deviceService.updateDevice(_this.device);
                    window.eventBus.publish(BREAKPOINT_DEVICE_UPDATED, _this.device);
                });
                return mqListener;
            });
            var landscapeListener = matchMedia('(orientation: landscape)');
            landscapeListener.addEventListener('change', function (e) {
                _this.landscape = e.matches;
                window.eventBus.publish(BREAKPOINT_LANDSCAPE_UPDATED, _this.landscape);
            });
            this.landscapeMediaQueryListener = landscapeListener;
        }
        this.device = this.lastMatch;
        this.deviceService.updateDevice(this.device);
        window.eventBus.publish(BREAKPOINT_DEVICE_UPDATED, this.device);
        this.landscape = this.isLandscape;
        window.eventBus.publish(BREAKPOINT_LANDSCAPE_UPDATED, this.landscape);
    };
    CssBreakpointsV2Service.prototype.isDesktop = function () {
        return [CssDevice.DESKTOP, CssDevice.LARGE].indexOf(this.device) !== -1;
    };
    Object.defineProperty(CssBreakpointsV2Service.prototype, "lastMatch", {
        get: function () {
            return (this.devices[this.mediaQueryListeners
                .map(function (mql) { return mql.matches; })
                .lastIndexOf(true)] || CssDevice.MOBILE);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CssBreakpointsV2Service.prototype, "isLandscape", {
        get: function () {
            if (this.landscapeMediaQueryListener) {
                return this.landscapeMediaQueryListener.matches;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return CssBreakpointsV2Service;
}());

export { CssBreakpointsV2Service };
